<template>
    <div class="flex-grid flex-align-center rounded overflow-hidden">
        <div class="flex-sm-5">
            <div class="bg-default-1 rounded overflow-hidden pos-relative aspect aspect-blog-image">
                <img
                    :alt="item.content.title"
                    :data-src="image"
                    class="lazy lazy-fade pos-absolute h-full"
                    style="object-fit: cover"
                />
            </div>
        </div>
        <div class="flex-sm-7">
            <p class="text-bold">
                <a :href="item.url" target="_blank">
                    {{ item.content.title }}
                </a>
            </p>
            <p class="text-small text-secondary">
                {{ date }} - {{ item.content.reading_time }} min de leitura
            </p>
            <p
                v-if="item.content.excerpt"
                :class="{ 'line-clamp-3': !expanded }"
                class="text-secondary"
            >
                {{ item.content.excerpt }}
            </p>
            <p class="text-small">
                <a class="text-primary cursor-pointer" @click="expanded = !expanded">
                    <span>
                        {{ expanded ? 'Ver menos' : 'Ver mais' }}
                        <i
                            :class="{
                                'icon-chevron-up': expanded,
                                'icon-chevron-down': !expanded,
                            }"
                            class="icon-cr"
                        />
                    </span>
                </a>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CountryRegionBlogPost',

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                expanded: false,
            };
        },

        computed: {
            date() {
                return this.item.content ? this.$f.formatDate(this.item.content.created_at) : null;
            },

            image() {
                const url = new URL(this.item.content.feature_image);
                if (url.host === 'blog.chicorei.com') {
                    url.host = 'imgblogchicorei.imgix.net';
                }
                return url.toString();
            },
        },
    };
</script>
